enum EStatusName {
  ACTIVE = "active",
  INACTIVE = "inactive",
  INVITED = "invited",
  EXPIRED = "expired",
  DELETED = "deleted",
}

export default EStatusName;
